import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    userName: null,
    userEmail: null,
    userLevel: null,
    redirectUrl: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginSuccess: (state, action) => {
            state.isAuthenticated = true;
            state.userEmail = action.payload.userEmail;
            state.userName =  action.payload.userName;
        },
        setRedirectUrl: (state, action) => {
            state.redirectUrl = action.payload;
        },
        clearRedirectUrl: (state) => {
            state.redirectUrl = null;
        },
        logout: (state) => {
            state.isAuthenticated = null;
            state.userEmail = null;
            state.userName = null;
        },
    },
});

export const {loginSuccess, logout, setRedirectUrl, clearRedirectUrl} = authSlice.actions;
export default authSlice.reducer;